document.addEventListener('DOMContentLoaded', function () {
    const bannerProductSection = document.querySelector('.banner-product');
    if (!bannerProductSection) return;

    updateTitleFontSize(bannerProductSection)
    window.addEventListener('resize', debounce(resizeHandler, 100));

    function resizeHandler() {
        updateTitleFontSize(bannerProductSection);
    }
})


function updateTitleFontSize(section) {
    const titleElement = section.querySelector('.banner-product__title h2');
    if (!titleElement) return;

    const sectionWidth = section.offsetWidth;
    let fontSize = parseInt(window.getComputedStyle(titleElement).fontSize.replace('px', ''));

    let maxIterations = 1000;
    let iterations = 0;

    while (titleElement.offsetWidth > sectionWidth && iterations < maxIterations) {
        fontSize--;
        titleElement.style.fontSize = fontSize + 'px';
        iterations++;
    }

    while (titleElement.offsetWidth < sectionWidth && iterations < maxIterations) {
        fontSize++;
        titleElement.style.fontSize = fontSize + 'px';
        if (titleElement.offsetWidth > sectionWidth) {
            fontSize--;
            titleElement.style.fontSize = fontSize + 'px';
            break;
        }
        iterations++;
    }

    if (iterations === maxIterations) {
        console.warn('Max iterations reached while adjusting font size.');
    }
}
